<template> 
    <div class="row">
        <div class="col-12">
            <div class="col-12">
                <h1 class="title-tab-content"> آدرس های من</h1>
            </div>
            <div class="content-section default">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 address-div">
                    <div class="col-md-4 col-sm-6 col-xs-12 address-div-child" v-for="userAddress in userAddresses">
                        <div class="box profile setaddress">
                            <span class="title" data-bind="text :  Title">{{userAddress.Title}}</span>
                            <span class="desc" data-bind="text : Address">{{userAddress.Address}}</span>
                            <div class="col-1-12 mt30 center">
                                <button @click="findCustomerAddress(userAddress.Id)" data-dialog="somedialog" data-toggle="modal" class="btn  action smal edit-btn">ویرایش</button>
                                <button @click="deleteAddress(userAddress.Id)" class="btn action small delete-btn">حذف</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12 address-div-child">
                        <div class="box profile no-address">

                            <img src="/assets/img/svg/icon-add-address.svg" alt="">
                            <span class="desc">
                                می‌توانید با ثبت آدرس‌ جدید، لیست آنها را در این بخش
                                مشاهده کنید
                            </span>
                            <div class="col-1-12 mt30 center">
                                <a @click="openAddAddressModal" class="btn green action small add-btn" data-dialog="somedialog">
                                    ثبت
                                    آدرس جدید
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Modal Add -->
                <add-address-modal></add-address-modal>
                <!-- /Modal Add-->
                <!-- Modal Edit-->
                <edit-address-modal :addressInfo="addressInfo"></edit-address-modal>
                <!-- /Modal Edit -->
                <!-- Modal CitySelector -->
                <city-selector-modal></city-selector-modal>
                <!-- /Modal CitySelector -->
            </div>
        </div>
        <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:50%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
    </div>
</template>

<script>

    import { httpPromise } from "../../../module/httpUtility";
    import addAddressModal from "./addAddressModal.vue";
    import citySelectorModal from "./citySelectorModal.vue"
    import editAddressModal from "./editAddressModal.vue";
    import { addressChangedEventBus } from "../../../eventBus/eventBus";
    export default {
        data() {
            return {
                userAddresses: {},
                addressInfo: {},
                isShowSppiner: false

            }
        },
        components: {
            'city-selector-modal': citySelectorModal,
            'add-address-modal': addAddressModal,
            'edit-address-modal': editAddressModal,
        },

        created: function () {
            createPageTitle('آدرس های من');
            this.readCustomersAddress();
            addressChangedEventBus.$on('customerAddressesUpdated', () => {
                this.readCustomersAddress();
            });
        },
        beforeDestroy() {
            addressChangedEventBus.$off('customerAddressesUpdated');
        },
        methods: {
            readCustomersAddress() {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/Identity/CustomersAddress/Read', 'get', '',
                    response => {
                        this.userAddresses = response.data.Value;
                        this.isShowSppiner = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            },
            openAddAddressModal() {
                $(function () {
                    $('#addAddressModal').modal({ backdrop: 'static', keyboard: false });
                    $('#addAddressModal').modal('show');
                });
            },
            findCustomerAddress(addressId) {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/Identity/CustomersAddress/Find', 'get', { AddressId: addressId },
                    response => {
                        toastr.remove();
                        this.addressInfo = response.data.Value;
                        this.isShowSppiner = false;
                        $(function () {
                            $('#editAddressModal').modal({ backdrop: 'static', keyboard: false });
                            $('#editAddressModal').modal('show');
                        });
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            },

            deleteAddress(addressId) {
                if (confirm("آیا از حذف این آدرس اطمینان دارید ؟")) {
                    this.isShowSppiner = true;
                    httpPromise(this, '/v1/Identity/CustomersAddress/Delete', 'delete', { AddressId: addressId },
                        response => {
                            toastr.remove();
                            toastr.success(response.data.Message);
                            this.isShowSppiner = false;
                            this.readCustomersAddress();
                        },
                        response => {
                            toastr.remove();
                            toastr.error(response.data.Message);
                            this.isShowSppiner = false;
                        });
                }
            },
        }
    }
</script>

<style scoped>

    .loader-bg-black {
        position: absolute;
        background-color: #80808033;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999;
        width: 100%;
        height: 100%
    }

        .loader-bg-black img {
            position: absolute;
            top: 50%;
            left: 48%;
            z-index: 100
        }

    .input-field {
        padding: 11px 11px 11px 11px !important;
    }

    .modal-content .modal-header button {
        right: unset !important;
        left: 27px !important;
        top: 30px !important;
    }

    .modal-header .close {
        padding: unset !important;
        margin: -1rem -1rem -1rem auto;
    }

    .setaddress {
        padding: 22px !important;
    }

    a:not([href]):not([tabindex]) {
        color: #fff;
    }

    .box.profile .center {
        text-align: center;
    }

    .box.no-address .desc {
        display: block;
        margin: 0 auto;
    }

    .box.profile.no-address img {
        margin-bottom: 25px;
    }

    .box.no-address {
        text-align: center;
        color: #777777;
    }

    .address-div {
        display: inline-block;
        overflow: hidden;
        min-height: 450px
    }

        .address-div .address-div-child {
            float: right;
        }

    .box profile {
        min-height: 200px;
        width: auto;
    }

    .box {
        background: #fcfcfc;
        border: 1px solid #e5e5e5;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        padding: 15px;
        width: 100%;
        margin-top: 15px;
    }

        .box .title {
            display: block;
            font-weight: 500;
            text-align: center;
        }

        .box .location {
            font-size: 12px;
            color: #777777;
            display: block;
            text-align: center;
            margin-top: 5px;
        }

        .box .desc {
            margin-top: 15px;
            text-align: center;
            display: block;
            font-size: 12px;
        }

        .box.profile .center {
            text-align: center;
        }

    .delete-btn, .delete-btn:active {
        border: 1px solid #dd6060;
        color: #dd6060 !important;
        background-color: #fff;
    }

    .edit-btn, .edit-btn:active {
        border: 1px solid #3871dd;
        color: #3871dd !important;
        background-color: #fff;
    }

    .add-btn, .add-btn:active {
        border: 1px solid #12b65c;
        color: #12b65c !important;
        background-color: #fff;
    }
</style>